import * as React from "react";
import { Table24Regular, Table24Filled } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const ResilienceHubApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "ResilienceHub" */ "./ResilienceHub");
    return { default: namedExport.ResilienceHub };
});

export const ResilienceHub: TeamAppConfig = {
    title: "Resilience Hub",
    regularIcon: Table24Regular,
    filledIcon: Table24Filled,
    description:
        "App that makes it easy and straightforward for service teams to improve their reliability in a measurable way " +
        "through leveling up their resilience.",
    team: "Foundation",
    publicId: "FoundationResilience",
    owner: "FndResilienceEng@microsoft.com",
    role: "*",
    tags: ["Foundation", "Resilience", "Fault Injection"],
    app: ResilienceHubApp,
    path: "/Foundation/ResilienceHub"
};
